import React from 'react';
import temperatureImage from '../images/temperature.png'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Dropdown} from "react-bootstrap";

// get the temperature from the server
class fetchHumidity extends React.Component {

    state = {
        loading: true,
        unit: 'C',
        userData: null,
        error: null
    };

    async componentDidMount() {
        try {
            // get last element of a json array
            const response = await fetch('https://iot-temphumid.herokuapp.com/temperature', {
                credentials: "include"
            });
            const json = await response.json();

            let temperature = json.length > 0 ? json[json.length - 1].temperature : "Can't get the temperature value";

            this.setState({
                loading: false,
                temperature: temperature,
                unit: "°C"
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    // function to convert the temperature from celsius to fahrenheit
    convertTemperature = () => {
        // three different cases, kelvin, celsius and fahrenheit
        if (this.state.unit === "K") {
            let temperature = this.state.temperature - 273.15;
            this.setState({
                temperature: temperature,
                unit: "°C"
            });
        } else if (this.state.unit === "°C") {
            let temperature = this.state.temperature * 1.8 + 32;
            this.setState({
                temperature: temperature,
                unit: "°F"
            });
        } else if (this.state.unit === "°F") {
            let temperature = (this.state.temperature - 32) / 1.8;
            this.setState({
                temperature: temperature,
                unit: "K"
            });
        }
        let temperature = this.state.temperature;
        let unit = this.state.unit;
        if (unit === "°C") {
            // save a cookie
            temperature = (temperature * 9 / 5) + 32;
            unit = "°F";
        }
        
        else {
            temperature = (temperature - 32) * 5 / 9;
            unit = "°C";
        }
        this.setState({
            temperature: temperature,
            unit: unit
        });
    }

    
    //drop down menu to pick the temperature
    render() {
        const { loading, temperature, error } = this.state;

        if (loading) {
            return <p>Loading...</p>;
        }

        if (error) {
            return <p>{error.message}</p>;
        }

        return (
            <div className="container text-center">
                <div className="row">
                    <div className="col-sm-12">
                        <h1>Temperature</h1>
                        <h2>{temperature} {this.state.unit}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <img src={temperatureImage} alt="temperature" className="img-fluid" width="300" height="300"/>
                    </div>
                </div>
                <div className="m-4">
                <Dropdown >
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        Change Unit
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={this.convertTemperature}>°C</Dropdown.Item>
                        <Dropdown.Item onClick={this.convertTemperature}>°F</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                </div>
            </div>
        );
    }
}

export default fetchHumidity;